import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationExtras } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  routeData: any;

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, reject) => {
        resolve(true);

      // if (route.firstChild && route.firstChild.data && route.firstChild.data.skipAuthCheck) {
      //   resolve(true);
      // } else {
      //   resolve(true);

        // this.authService
        //   .checkSession()
        //   .then(() => {
        //     resolve(true);
        //   })
        //   .catch(err => {
        //     const navigationExtras: NavigationExtras = {
        //       state: {
        //         routedFromPage: state.url
        //       }
        //     };
        //     this.router.navigate(['auth/unauthorized'], navigationExtras);
        //     reject();
        //   });
      //}
    });
  }
}
